// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strategy-guidance-card {
  position: relative;
  overflow: hidden;
}

.strategy-guidance-card__content--concealed {
  opacity: 0.1;
  filter: blur(2px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.strategy-guidance-card__mask {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0.9rem 0.8rem 0.8rem;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.strategy-guidance-card__actions {
  position: relative;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: auto;
}

.strategy-guidance-card__actions .analytics-toggle-icon:disabled {
  background: transparent;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.48;
}

.strategy-guidance-card__actions--concealed {
  display: none;
}

.dark .strategy-guidance-card__actions .analytics-toggle-icon:disabled {
  color: #6b7280;
}

.strategy-guidance-card__mask-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.34rem;
  color: #f8fafc;
  text-align: center;
}

.strategy-guidance-card__mask-content strong {
  font-size: 0.82rem;
}

.strategy-guidance-card__mask-content span {
  color: rgba(248, 250, 252, 0.82);
  font-size: 0.7rem;
  line-height: 1.35;
}

.strategy-guidance-card__reveal-btn {
  margin-top: 0.2rem;
  padding: 0.42rem 0.82rem;
  border: 0;
  border-radius: 999px;
  background: #f8fafc;
  color: #111827;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);
  transition: transform 150ms ease, box-shadow 150ms ease;
}

.strategy-guidance-card__reveal-btn:hover {
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
}

.strategy-guidance-card__reveal-btn:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportSpecificStrategiesPanel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".strategy-guidance-card {\n  position: relative;\n  overflow: hidden;\n}\n\n.strategy-guidance-card__content--concealed {\n  opacity: 0.1;\n  filter: blur(2px);\n  pointer-events: none;\n  user-select: none;\n}\n\n.strategy-guidance-card__mask {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0.9rem 0.8rem 0.8rem;\n  background: rgba(15, 23, 42, 0.58);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.strategy-guidance-card__actions {\n  position: relative;\n  z-index: 3;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-left: auto;\n}\n\n.strategy-guidance-card__actions .analytics-toggle-icon:disabled {\n  background: transparent;\n  color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.48;\n}\n\n.strategy-guidance-card__actions--concealed {\n  display: none;\n}\n\n.dark .strategy-guidance-card__actions .analytics-toggle-icon:disabled {\n  color: #6b7280;\n}\n\n.strategy-guidance-card__mask-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.34rem;\n  color: #f8fafc;\n  text-align: center;\n}\n\n.strategy-guidance-card__mask-content strong {\n  font-size: 0.82rem;\n}\n\n.strategy-guidance-card__mask-content span {\n  color: rgba(248, 250, 252, 0.82);\n  font-size: 0.7rem;\n  line-height: 1.35;\n}\n\n.strategy-guidance-card__reveal-btn {\n  margin-top: 0.2rem;\n  padding: 0.42rem 0.82rem;\n  border: 0;\n  border-radius: 999px;\n  background: #f8fafc;\n  color: #111827;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);\n  transition: transform 150ms ease, box-shadow 150ms ease;\n}\n\n.strategy-guidance-card__reveal-btn:hover {\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);\n}\n\n.strategy-guidance-card__reveal-btn:focus-visible {\n  outline: 2px solid #93c5fd;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
